import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getSingleJob, postSingleJob, resetToggleisUpdateJobSuccessFull, updateSingleJob } from '../features/jobs/jobSlice';

const positionsOption = [
    { id: 1, name: 'Select Job' }
    , { id: 2, name: 'Software Engineer' }
    , { id: 3, name: 'Software Developer' }
    , { id: 4, name: 'Stack Developer' }
    , { id: 5, name: 'Stack Developer' }
    , { id: 6, name: 'DevOps Engineer' }
    , { id: 7, name: 'QA Engineer' }
    , { id: 8, name: 'Product Manager' }
    , { id: 9, name: 'Media Manager' }
    , { id: 10, name: 'Senior Executive' }
    , { id: 11, name: 'Junior Executive' }
    , { id: 12, name: 'App Developer' }
    , { id: 13, name: 'App Developer' }
    , { id: 14, name: 'Frontend Developer' }
    , { id: 15, name: 'Frontend Engineer' }
]
const jobType = [

    { id: 1, name: 'Select Job Type' },
    { id: 2, name: 'Full Time' },
    { id: 3, name: 'Internship' },
    { id: 4, name: 'Remote' }
]

const AddJob = () => {

const {jobDetails,isUpdateJobSuccessFull}=useSelector(state=>state.jobs);
const {id:jobId}=useParams()



    const [formData, setFormData] = useState({
        title: "",
        type: "",
        salary: "",
        deadline: "",
    });

    const handleForm = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

 
    const dispatch = useDispatch();

    useEffect(()=>{
       if(jobDetails.id && jobId){

           setFormData(jobDetails)
       }
        
        },[jobDetails,jobId])

        useEffect(()=>{
            if(jobId){

                dispatch(getSingleJob(jobId))
            }
        },[jobId])
    

    const formInputs = [
        {

            name: 'title',
            label: 'Job Title',
            type: 'select',
            placeholder: '',
            optionsList: positionsOption
            , required: true

            , id: "lws-JobTitle",
            value: formData.title

        },
        {

            name: 'type',
            label: 'Job Type',
            type: 'select',
            placeholder: '',
            optionsList: jobType
            , required: true,
            id: "lws-JobType",
            value: formData.type


        },
        {

            name: 'salary',
            label: 'Salary',
            type: 'number',
            placeholder: "20,00,000",
            extraWord: 'BDT'
            , required: true
            , id: "lws-JobSalary",
            value: formData.salary


        },
        {

            name: 'deadline',
            label: 'Deadline',
            type: 'date',
            required: true
            , id: "lws-JobDeadline",
            value: formData.deadline

        },
    ];

const navigate =useNavigate();

useEffect(() => {
if(isUpdateJobSuccessFull){
    dispatch(resetToggleisUpdateJobSuccessFull())

  const prevUrl =  localStorage.getItem('prevUrl')
    navigate(prevUrl||'/')

    localStorage.removeItem('prevUrl')
}
}, [isUpdateJobSuccessFull])

const  handleFormSubmit=(e)=>{
   
        e.preventDefault();

        formData?.id ? dispatch(updateSingleJob(formData)) :dispatch(postSingleJob(formData))
       
    
}

    return (
        <>
            <div className="lg:pl-[14rem] mt-[5.8125rem]">
                <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
                    <h1 className="mb-10 text-center lws-section-title">Add New Job</h1>
                    <div className="max-w-3xl mx-auto">
                        <form className="space-y-6" onSubmit={handleFormSubmit}>

                            {
                                formInputs.map(field => 

                                    {
                                        const {optionsList, ...rest}=field;
                                      
                                        
                                        
                                        return <div className="fieldContainer" key={field.id}>

                                        <label htmlFor={field.id} className="text-sm font-medium text-slate-300">{field.label}</label>



                                        {
                                            field.type === 'select' ?
                                                <select onChange={handleForm} {...rest}>
                                                    {
                                                        field.optionsList.map(position => (
                                                            <option key={position.id} value={position.value} >{position.name}</option>

                                                        ))
                                                    }
                                                </select>
                                                :
                                                <div className="flex border rounded-md shadow-sm border-slate-600">
                                                    {field?.extraWord && <span className="input-tag">{field?.extraWord}</span>}
                                                    <input onChange={handleForm} className="!rounded-l-none !border-0"  {...rest} />
                                                </div>
                                        }


                                    </div>}
                                )
                            }

                           
                            <div className="text-right">
                                <button type="submit" id="lws-submit" className="cursor-pointer btn btn-primary w-fit">
                                    {formData?.id ? 'Edit' : 'Add'}
                                </button>
                            </div>
                        </form>
                    </div>
                </main>
            </div>
        </>
    )
}

export default AddJob